<template>
  <hc-table :tableData="state.improveTable" :column="state.improveColumn" :isHidePage="true" />
</template>

<script setup>
import hcTable from "@/components/hc-home/table.vue";
import { pageListApi as improveSubmitApi } from "@/api/improve/record.js";
import { onMounted, reactive } from "vue";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyImproveTodoColumns } from "@/utils/homeDashboardI18n.js";

const state = reactive({
  improveTable: [],
  improveColumn: [
    { type: "index", label: "序号", width: 60 },
    { prop: "title", label: "任务名称" },
    { prop: "real_name", label: "提交人" },
    { prop: "score", label: "分值", width: 70 },
    { prop: "created_at", label: "创建时间", width: 160 },
  ],
})

const applyLabels = () => {
  applyImproveTodoColumns(state.improveColumn)
}
const { t } = usePageI18n(applyLabels)

const getImproveAuditList = () => {
  improveSubmitApi(JSON.stringify({
    page: 1,
    limit: 8,
    status: 2,
    keywords: ""
  })).then(res => {
    state.improveTable = res?.data ?? []
  })
};

onMounted(() => {
  applyLabels()
  getImproveAuditList()
})
</script>
